<template>
  <div class="parent-area">
    <div class="parent-name">
      <span class="parent-name-text">{{ parent.name }}</span>
    </div>
    <div class="parent-scope" style="padding: 0rem 0.5rem;">
      <span class="parent-scope-text">
        {{ parent.startupTime | formatDateValue }} 至 {{ parent.completedTime | formatDateValue }}
      </span>
    </div>
    <div class="parent-scope"
      style="padding: 0rem 0.5rem 0.5rem 0.5rem;"
      v-if="(parent.dutyScope || '') !== ''">
      <span class="parent-scope-text">
        {{ (parent.dutyScope || '').split('||').join('、') }}
      </span>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/util/dateUtils';

export default {
  props: ['parent'],
  data() {
    return {

    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .parent-area {
    background-color: $panel-bg-color;
  }

  .parent-name {
    text-align: center;
    padding: 0.5rem 0.5rem;
  }

  .parent-name-text {
    display: inline-block;
    text-align: left;
    font-size: 1rem;
  }

  .parent-scope {
    text-align: center;
    padding: 0.1rem 0.5rem;
  }

  .parent-scope-text {
    display: inline-block;
    text-align: left;
    color: $second-font-color;
    font-size: 0.9rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/ParentHeader.vue